import { ApiResult } from '@src/api/apiClient/apiResult';
import { axiosClient } from '@src/api/apiClient/axiosClient';

export type UserNavigationItem = {
  title: string;
  link: string;
};

type UserNavigationResponse = UserNavigationItem[];

export const UserNavigationApiClient = {
  get: async (): Promise<ApiResult<UserNavigationResponse>> => {
    return await axiosClient.get('/company/user-navigation');
  },
};
